
/** @type { import("./Glob").Glob } */
export const Glob = window.glob;

export default Glob;
